import React, { useState } from 'react';
import { validateEmail } from '../../../API';
import InputTextField from '../../../BuildingBlocks/Form/TextField';
import InvalidEmail from './InvalidEmail';

export default function EmailField({ errors, register, email, emailWatch }) {
  const [invalidEmail, setInvalidEmail] = useState(false);

  async function handleOnBlur() {
    if (!emailWatch) return;
    try {
      const emailValidation = await validateEmail({
        email: emailWatch,
        source: 'signup',
      });
      if (emailValidation['verdict'] === 'Invalid') {
        setInvalidEmail(true);
      } else {
        setInvalidEmail(false);
      }
    } catch (e) {
      setInvalidEmail(false);
    }
  }

  function handleOnFocus() {
    setInvalidEmail(false);
  }

  const error = errors && errors['email'];

  return (
    <InputTextField
      errors={errors}
      label={'E-mail'}
      name={'email'}
      defaultValue={email}
      TextFieldProps={{
        ...register('email'),
      }}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      helperText={invalidEmail && !error ? <InvalidEmail /> : null}
    />
  );
}
